import { AIRFLOW_PROVIDER } from '../../constants/airflow';
import { SQL_PROVIDER } from '../../constants/sql';
import { DQ_PROVIDER } from './types/dataQuality';
import { ORCHESTRATION_PROVIDER } from './types/orchestration';
import { SPARK_PROVIDER } from './types/spark';

export enum FabricProviderType {
  Spark = 'Spark',
  SQL = 'SQL',
  Airflow = 'Airflow',
  DataQuality = 'Data Quality',
  Orchestration = 'Prophecy'
}

export enum SQLFabricProviderType {
  SQL = 'SQL',
  Orchestration = 'Prophecy',
  OrchestrationWithPython = 'OrchestrationWithPython'
}

export type FabricSource = FabricProviderType | SQLFabricProviderType;

export type FabricProviderMap = {
  [FabricProviderType.SQL]: SQL_PROVIDER;
  [FabricProviderType.Spark]: SPARK_PROVIDER;
  [FabricProviderType.Airflow]: AIRFLOW_PROVIDER;
  [FabricProviderType.DataQuality]: DQ_PROVIDER;
  [FabricProviderType.Orchestration]: ORCHESTRATION_PROVIDER;
};

export type UserSQLCreds = { fabrics: Record<string, { authType?: string }> };

export type GENERIC_PROVIDER = SPARK_PROVIDER | SQL_PROVIDER | AIRFLOW_PROVIDER | DQ_PROVIDER | ORCHESTRATION_PROVIDER;

export type FabricErrorReason =
  | 'bad-gateway'
  | 'default'
  | 'missing-cluster-id'
  | 'invalid-cluster-id'
  | 'login-required';
